module.exports = __webpack_public_path__ + "img/シトロエン.b8ca75f8.png";